<template>
  <div class="country-select" :class="{ 'country-select--error': error }">
    <multiselect
      :value="selected"
      :options="options"
      :searchable="true"
      :allow-empty="true"
      :show-labels="false"
      track-by="code"
      label="label"
      :placeholder="resolvedPlaceholder"
      @input="onInput"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <span>{{ option.label }}</span>
      </template>
      <template slot="option" slot-scope="{ option }">
        <div class="cs-option">
          <span>{{ option.label }}</span>
          <small>{{ option.code }}</small>
        </div>
      </template>
      <template slot="noResult">{{ $t("invoicesMisc.country.noResult") }}</template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { buildCountryOptions } from "@/utils/countryOptions";

/**
 * Selector de país REUTILIZABLE (multiselect con banderas + búsqueda) — el mismo
 * en todos los modales de factura (crear/editar en la reserva y en el módulo de
 * Facturación) para no tener listas distintas ni componentes distintos.
 *
 * v-model: código ISO del país ("ES", "FR"…). Opcional: value vacío = sin país.
 */
export default {
  name: "CountrySelect",
  components: { Multiselect },
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    error: { type: Boolean, default: false },
  },
  data() {
    return {
      options: buildCountryOptions((this.$i18n && this.$i18n.locale) || "es"),
    };
  },
  computed: {
    resolvedPlaceholder() {
      return this.placeholder || this.$t("invoicesMisc.country.placeholder");
    },
    selected() {
      const code = String(this.value || "").toUpperCase();
      return this.options.find((o) => o.code === code) || null;
    },
  },
  methods: {
    onInput(opt) {
      this.$emit("input", opt ? opt.code : "");
    },
  },
};
</script>

<style scoped>
/* Mismo look EXACTO que el multiselect del modal de crear factura
   (ManualInvoiceCreateModal): input redondeado, foco morado, resaltado morado
   de la opción y código a la derecha. */
.country-select :deep(.multiselect) { min-height: 40px; }
.country-select :deep(.multiselect__tags) {
  min-height: 40px; border-radius: 10px; border: 1px solid #e2e8f0;
  padding: 10px 38px 0 13px; font-size: 13.5px; color: #0f172a;
  background: #f9fafc; transition: border-color .12s, box-shadow .12s, background .12s;
}
.country-select :deep(.multiselect__tags:hover) { background: #f4f6fa; }
.country-select :deep(.multiselect--active .multiselect__tags) {
  background: #fff; border-color: #5e71e4; box-shadow: 0 0 0 3.5px rgba(94, 114, 228, .12);
}
/* .multiselect__single trae background:#fff por defecto → parecía una caja blanca
   dentro del contenedor gris. Transparente para que se integre. */
.country-select :deep(.multiselect__input),
.country-select :deep(.multiselect__single) { background: transparent; padding-left: 0; }
.country-select :deep(.multiselect__placeholder) {
  color: #94a3b8; font-size: 13.5px; margin: 0; padding: 0;
}
.country-select :deep(.multiselect__single),
.country-select :deep(.multiselect__input),
.country-select :deep(.multiselect__option) {
  font-size: 13.5px; font-family: 'DM Sans', system-ui, sans-serif; margin: 0; padding: 0;
}
.country-select :deep(.multiselect__select) { height: 42px; right: 0; display: flex; align-items: center; }
.country-select :deep(.multiselect__content-wrapper) {
  border-radius: 10px; border: 1px solid #e2e8f0;
  box-shadow: 0 12px 30px rgba(15, 23, 42, .14); margin-top: 4px;
}
.country-select :deep(.multiselect__option) { padding: 10px 13px; }
.country-select :deep(.multiselect__option--highlight) { background: #5e71e4; }
.country-select :deep(.multiselect__option--highlight::after) { background: #5e71e4; }
.country-select--error :deep(.multiselect__tags) { border-color: #c62828; }

.cs-option { display: flex; justify-content: space-between; gap: 10px; width: 100%; }
.cs-option small { color: #94a3b8; font-size: 11px; }
</style>
